// extracted by mini-css-extract-plugin
export default {"priceBlock":"calc-result_priceBlock__Bfg6b","content":"calc-result_content__sDjpX","selected":"calc-result_selected__HB59G"};